export var ShowMode;
(function (ShowMode) {
    ShowMode[ShowMode["Closed"] = 0] = "Closed";
    ShowMode[ShowMode["Manual"] = 1] = "Manual";
    ShowMode[ShowMode["Auto"] = 2] = "Auto";
})(ShowMode || (ShowMode = {}));
//# sourceMappingURL=ShowMode.js.map